/**
 * Return the default booking duration to be used in the data pickers and search form
 * @returns {number|*}
 */
const getDefaultBookingDurationHours = () => 4;

export default getDefaultBookingDurationHours;
